/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchWorkersCoinResponse } from './search-workers-coin-response';
import { WorkerStatus } from './worker-status';
import { WorkerSources } from './worker-sources';


export interface SearchWorkersResponse { 
    id: string;
    name: string;
    displayName: string;
    clientName: string;
    poolName: string;
    equipmentQuantity: number;
    equipmentUnderRepairQuantity: number;
    totalHashrate: number;
    coin: SearchWorkersCoinResponse;
    status: WorkerStatus;
    source: WorkerSources;
    isEditable: boolean;
}



